import { IAppState } from '../../../../../AppModulesWrapper';

import { EMoneySource } from '../../../../types/reducers/user';
import { selectAvailableMoneySources } from './selectAvailableMoneySources';

export function selectPlacingMoneySource(state: IAppState): EMoneySource | null {
  const moneySources = selectAvailableMoneySources(state);

  return moneySources.find(source => source.selected)?.type || null;
}
